var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c(_vm.answer_blocks[_vm.answer_block_data.type],{tag:"component",attrs:{"answer_values":_vm.answer_block_data.values},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }